import React, { useCallback } from "react";
import { WidgetEmployeeLeaveSettingsStackScreenProps } from "./WidgetEmployeeLeaveSettingsStack";
import { graphql, useLazyLoadQuery } from "react-relay";
import { useModalInsets } from "@/src/components/mobile/useModalInsets";

import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import { WidgetEmployeeLeaveSettingsTeamsQuery } from "./__generated__/WidgetEmployeeLeaveSettingsTeamsQuery.graphql";
import { useWidgetSettingsEmployeeLeaveContext } from "./WidgetEmployeeLeaveSettingsContext";
import {
  TeamSelectList,
  TeamSelectListWholeStoreOption,
} from "widgets/src/TeamSelectList";

function WidgetEmployeeLeaveSettingsTeamsC({ fetchKey }: { fetchKey: string }) {
  const { teamIds, setTeamIds } = useWidgetSettingsEmployeeLeaveContext();
  const data = useLazyLoadQuery<WidgetEmployeeLeaveSettingsTeamsQuery>(
    graphql`
      query WidgetEmployeeLeaveSettingsTeamsQuery {
        store {
          publicTeams {
            ...TeamSelectList_Team
          }
        }
      }
    `,
    {},
    {
      fetchKey,
      fetchPolicy: "store-and-network",
    }
  );
  const { store } = data;

  const onItemPress = useCallback(
    (itemId: string, _selected: boolean) => {
      setTeamIds((prev) => {
        const selected = prev.includes(itemId);
        if (selected) {
          return prev.filter((id) => id !== itemId);
        }
        return [...prev, itemId];
      });
    },
    [setTeamIds]
  );

  const insets = useModalInsets();
  return (
    <TeamSelectList
      insets={insets}
      teams={store?.publicTeams ?? []}
      selected={teamIds}
      contentBox={{ spaceTop: "medium" }}
      ListHeaderComponent={
        <TeamSelectListWholeStoreOption
          onSelect={() => setTeamIds([])}
          selected={teamIds.length === 0}
        />
      }
      onItemPress={onItemPress}
    />
  );
}

export function WidgetEmployeeLeaveSettingsTeams(
  props: WidgetEmployeeLeaveSettingsStackScreenProps<"WELSTeams">
) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fk) => <WidgetEmployeeLeaveSettingsTeamsC fetchKey={fk} />}
    </LazyQueryNetworkBoundrary>
  );
}
